import { pluginFigure } from "./../plugin-figure";
import { IMAGE_TYPE, TIPTAP_IMAGE_TYPE } from "./../ricos-content";
import { RicosPluginToolbarNames } from "./../ricos-types";
import { DEFAULTS } from "./consts";
import { imageConverter } from "./converter/image-converter";
import { getAddButtons } from "./getAddButtons";
import { getToolbarButtons } from "./getToolbarButtons";
import { Settings } from "./settings/settings";
import { imageTiptapExtension } from "./tiptap/image-tiptap-extension";
const pluginImage = (config) => {
  const pluginConfig = { ...DEFAULTS.config, ...config };
  return {
    config: pluginConfig,
    type: IMAGE_TYPE,
    pmMarkConverters: [],
    pmNodeConverters: [imageConverter],
    tiptapExtensions: [imageTiptapExtension],
    toolbar: {
      names: [RicosPluginToolbarNames.IMAGE],
      getButtons: (config2, services) => getToolbarButtons(config2, services),
      resolveReferenceElement: (tiptapEditor) => {
        const startNodePos = tiptapEditor.state.selection.$from;
        if (startNodePos.nodeAfter?.type.name !== TIPTAP_IMAGE_TYPE) {
          return null;
        }
        return tiptapEditor.view.nodeDOM(startNodePos.pos - 1);
      }
    },
    getAddButtons: (config2, services) => getAddButtons(config2, services),
    __exports: {
      SettingsModal: Settings
    },
    dependencies: [pluginFigure]
  };
};
export {
  pluginImage
};
//# sourceMappingURL=editor.js.map

import { injectCss } from "./viewer-styles-inject";
injectCss();
